const createAction = <Resource extends string>(resource: Resource) => ({
  Read: {
    Self: `${resource}.Read.Self` as const,
    All: `${resource}.Read.All` as const,
  },
  Write: {
    Self: `${resource}.Write.Self` as const,
    All: `${resource}.Write.All` as const,
  },
});

export const Actions = {
  Timetable: createAction('Timetable'),
  Student: createAction('Student'),
  Feedback: createAction('Feedback'),
  Notification: createAction('Notification'),
} as const;

export type ActionResource = (typeof Actions)[keyof typeof Actions];
export type ActionType = ActionResource[keyof ActionResource];
export type ActionValue = ActionType[keyof ActionType] & string;
